import { Box, Text } from '@chakra-ui/react';
import DefaultLayout from '@components/layout/layout/DefaultLayout';
import { useEffect } from 'react';

declare global {
  interface Window {
    fbq?: (...args: any[]) => void;
  }
}

const CalendlyConfirmationPage = () => {
  useEffect(() => {
    if (typeof window !== 'undefined' && window.fbq) {
      window.fbq('track', 'Schedule');
    }
  }, []);

  return (
    <DefaultLayout showFooter={false}>
      <Box mx="auto">
        <Text fontSize="5xl" mt="10">
          Thank you!
        </Text>
        <Text fontSize="2xl" mb="100">
          Your call is scheduled and we're looking forward to guiding you through the Medicare maze.
        </Text>
      </Box>
    </DefaultLayout>
  );
};

export default CalendlyConfirmationPage;
